// Function to dismiss notification and set a cookie
function dismissNotification() {
    const notificationID = this.getAttribute('data-notification-id');
    
    // Set a cookie with the notification ID
    setCookie(`dismissed_notification_${notificationID}`, "1", 30);

    // Hide the specific notification on the frontend
    const notificationElement: HTMLElement = document.querySelector(`#notification-${notificationID}`);
    if (notificationElement) {
        notificationElement.style.display = "none";
    }
}

// Function to set cookies
function setCookie(name: string, value: string | number | boolean, days: number) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
}

// Function to get notifications based on current date
function getNotifications() {
    let notifications = null;
    notifications = document.querySelectorAll('.notification');
    return notifications;
}

// Run the code only if there are notifications on the page
function initNotifications() {
    const notifications = getNotifications();
    if (notifications && notifications.length > 0) {
        notifications.forEach((item) => {
            item.querySelector('.dismiss').addEventListener('click', dismissNotification);
        });
    }
}

initNotifications();
